/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../../Fct/createPlugin';
import { FctAddress, FctAddressList, FctTimestamp, FctValue } from '../../../../../Fct/generics';
import { getAllCurrencies } from '../../../../../Fct/plugins/allowanceRequiredProtocols';
import { ROUTER_V2_ADDRESSES } from '../../constants';
import { amountOutMinRisk } from '../params';
export var UniswapV2SwapExactETHForTokens = createPlugin({
    protocol: 'UNISWAP',
    type: 'ACTION',
    method: 'swapExactETHForTokens',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'uniswap_router' }),
                value: new FctValue({ destination: 'wei_amount', isPreview: true }),
                methodParams: {
                    amountOutMin: new FctValue({ destination: 'wei_amount', risk: amountOutMinRisk }),
                    path: new FctAddressList({ destination: 'ERC20_List', options: getAllCurrencies({ chainId: chainId }), isPreview: true }),
                    to: new FctAddress({}),
                    deadline: new FctTimestamp({}),
                },
            },
            output: {
                amountIn: new FctValue({ destination: 'wei_amount', innerIndex: 2, innerType: 'uint256[]' }),
                amountOut: new FctValue({ destination: 'wei_amount', innerIndex: -1, innerType: 'uint256[]' }),
            },
        });
    },
    supportedContracts: ROUTER_V2_ADDRESSES,
    initParams: {
        methodParams: {
            deadline: { type: 'global', id: 'blockTimestamp' },
        },
    },
});
